import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, ElementRef, Inject, ViewChild, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import { Constant } from 'src/app/constant/constant';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-media-picker-dialog',
  templateUrl: './media-picker-dialog.component.html',
  styleUrls: ['./media-picker-dialog.component.scss']
})
export class MediaPickerDialogComponent implements OnDestroy {


  url = '';
  sanitizedUrl = '';

  @ViewChild("myInput") myInputVariable: ElementRef;
  public uploader: FileUploader = new FileUploader({
    isHTML5: true,
    allowedFileType: ['image', 'video', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'audio']
  });

  caption = '';
  uploadedMediaFileName: string;
  uploadedMediaType: string;
  uploadedMediaUrl: string;
  mimeType: string;
  uploadProgress = 0;
  uploadInProgress = false;
  selectedType: any;
  data1: any;

  constructor(
    public dialogRef: MatDialogRef<MediaPickerDialogComponent>,
    private snackbar: MatSnackBar,
    private fileUploadService: FileUploadService,
    @Inject(MAT_DIALOG_DATA) public data: any, private router: Router
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });
    this.selectedType = data?.selectedType ?? null;
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map(item => item.file);
  }

  upload(): void {
    const files = this.getFiles();
    const data = new FormData();

    if (files.length > 0) {
      this.uploadInProgress = true;

      files.forEach((file: any) => {
        data.append('files', file.rawFile, file.name.replace(/\s/g, "_").replace(/\(/g, '_').replace(/\)/g, '_'));
      });

      this.fileUploadService.normalUploadFiles(data, 'whatsapp', 'calsoftgroup.com').subscribe({
        next: (res: any) => {

          this.data1 = res;
          if (res && res.status_code === '500') {
            this.snackbar.open(res.status_message || 'An error occurred during upload', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
            this.uploadInProgress = false;
            return;
          }
          this.uploadProgress = 100;
          this.uploader.clearQueue();
          this.myInputVariable.nativeElement.value = "";
          const fileName = res?.productEntityMediaGallery?.[0]?.fileName ?? '';
          if (fileName) {
            this.handleUploadedFile(fileName, files[0].type);
          }
        },
        error: () => {
          this.snackbar.open('Upload failed', 'Close', { duration: 3000 });
          this.uploadInProgress = false;
        }
      });
    } else {
      alert("No Items Found");
    }
  }

  handleUploadedFile(fileName: string, mime: string) {
    const cid = localStorage.getItem(Constant.enterPriseKey); // Replace with actual
    const basePath = environment.commonImageApi + '/whatsapp/';
    fileName = fileName.split('/').pop() || '';
    this.uploadedMediaFileName = fileName;
    this.mimeType = mime;
    this.uploadedMediaUrl = basePath + fileName + "&cid=" + cid;

    if (mime.includes('image')) this.uploadedMediaType = 'image';
    else if (mime.includes('video')) this.uploadedMediaType = 'video';
    else if (mime.includes('audio')) this.uploadedMediaType = 'audio';
    else this.uploadedMediaType = 'document';

    this.uploadInProgress = false;
  }

  close() {
    if (!this.uploadedMediaFileName || !this.uploadedMediaUrl || !this.uploadedMediaType) {
      this.snackbar.open('Please upload the media', 'Close', {
        duration: 3000,
        panelClass: ['error']
      });
      return;
    }

    this.dialogRef.close({
      fileName: this.uploadedMediaFileName,
      mediaType: this.uploadedMediaType,
      mediaUrl: this.uploadedMediaUrl,
      mimeType: this.mimeType,
      caption: this.caption
    });
  }

  closeAll() {
    this.dialogRef.close();
  }
  getAcceptedFileTypes(): string {
    switch (this.selectedType?.toLowerCase()) {
      case 'image':
        return 'image/*';
      case 'video':
        return 'video/*';
      case 'audio':
        return 'audio/*';
      case 'document':
        return '.pdf,.doc,.docx,.txt,.rtf,.odt,.xls,.xlsx,.ppt,.pptx,.csv';
      default:
        return '*/*'; // fallback to all files if type is not specified
    }
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}